import { render, staticRenderFns } from "./News-bg.vue?vue&type=template&id=8e8f48fc&scoped=true&"
import script from "./News-bg.vue?vue&type=script&lang=js&"
export * from "./News-bg.vue?vue&type=script&lang=js&"
import style0 from "./News-bg.vue?vue&type=style&index=0&id=8e8f48fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8f48fc",
  null
  
)

export default component.exports